import React from 'react';
import { cn } from '@/lib/utils';

export interface HeaderProps extends React.HTMLAttributes<HTMLDivElement> {
    backgroundColor?: string;
    headerWidth?: string;
}

export function Header({
    children,
    backgroundColor,
    headerWidth,
    className,
    style,
    ...props
}: HeaderProps): React.JSX.Element {
    return (
        <div
            className={cn(
                'flex flex-col justify-center rounded-t-none rounded-b-lg px-6 py-2.5 text-center text-white',
                className,
            )}
            style={{ backgroundColor, width: headerWidth || 'fit-content', ...style }}
            {...props}
        >
            <h5 className="text-xl leading-normal font-normal">{children}</h5>
        </div>
    );
}
